const _temp0 = require("../FlashModal/FlashModal.js");

const _temp1 = require("../Footer/Footer.js");

const _temp2 = require("../Header/Header.js");

const _temp3 = require("../LoadMore/LoadMore.js");

const _temp4 = require("../Parallax/Parallax.js");

const _temp5 = require("../Reveal/Reveal.js");

module.exports = {
  "FlashModal":   {
    "FlashModal": _temp0
  },
  "Footer":   {
    "Footer": _temp1
  },
  "Header":   {
    "Header": _temp2
  },
  "LoadMore":   {
    "LoadMore": _temp3
  },
  "Parallax":   {
    "Parallax": _temp4
  },
  "Reveal":   {
    "Reveal": _temp5
  }
}